(() => {
  'use strict';

  let bootAttempts = 0;

  /* PN_COMPARE_ICON_BOOT */

  function refreshLucideIcons(attempt = 0) {

    if (
      window.lucide &&
      typeof window.lucide.createIcons === 'function'
    ) {

      window.lucide.createIcons();

      return;
    }


    if (attempt < 30) {

      setTimeout(
        () => refreshLucideIcons(attempt + 1),
        100
      );

    }

  }



  const escapeHTML = value => {
    const el = document.createElement('div');

    el.textContent =
      value == null
        ? ''
        : String(value);

    return el.innerHTML;
  };


  const show = element => {
    if (!element) return;

    element.hidden = false;
    element.style.display = '';
    element.removeAttribute('aria-hidden');
  };


  const hide = element => {
    if (!element) return;

    element.hidden = true;
  };


  function boot() {
    const root =
      document.querySelector('[data-pnx]');

    if (!root) {
      return;
    }


    /*
      Supabase is loaded globally near </body>.
      Compare may execute slightly before it,
      so wait for it instead of failing silently.
    */

    if (!window.PeerNestDB) {
      bootAttempts += 1;

      if (bootAttempts <= 40) {
        setTimeout(boot, 100);
      }
      else {
        console.error(
          '[PeerNest Compare] PeerNestDB never became available.'
        );
      }

      return;
    }


    if (
      root.dataset.pnxCanonicalReady ===
      '1'
    ) {
      return;
    }

    root.dataset.pnxCanonicalReady =
      '1';

    /* PNX_COMPARE_MOBILE_TAP_TARGETS_START
       Compare mentor cards reuse generic mentor listing CSS. On phones the
       original 28px/6px targets are too small to tap accurately. Keep their
       two independent actions comfortably tappable without changing desktop.
    */
    if (!document.getElementById('pnx-compare-mobile-tap-targets')) {
      const tapStyle = document.createElement('style');
      tapStyle.id = 'pnx-compare-mobile-tap-targets';
      tapStyle.textContent = `
        @media screen and (max-width: 749px) {
          .pnx .pnx-mentor-stage .pnx-compare-mentor-card .pnm-card__actions {
            display: grid !important;
            grid-template-columns: 1fr !important;
            gap: 8px !important;
          }
          .pnx .pnx-mentor-stage .pnx-compare-mentor-card .pnm-card__action {
            position: relative !important;
            z-index: 2 !important;
            min-height: 44px !important;
            margin: 0 !important;
            padding: 8px 6px !important;
            font-size: 10px !important;
            line-height: 1.25 !important;
            touch-action: manipulation !important;
            -webkit-tap-highlight-color: rgba(45,114,173,.12);
          }
        }
      `;
      document.head.appendChild(tapStyle);
    }
    /* PNX_COMPARE_MOBILE_TAP_TARGETS_END */


    /*
      Render selector icons immediately.
      Previously these only appeared after Compare was clicked.
    */

    refreshLucideIcons();


    const selectA =
      root.querySelector(
        '[data-pnx-a]'
      );

    const selectB =
      root.querySelector(
        '[data-pnx-b]'
      );

    const compareButton =
      root.querySelector(
        '[data-pnx-compare]'
      );

    const errorBox =
      root.querySelector(
        '[data-pnx-error]'
      );

    const before =
      root.querySelector(
        '[data-pnx-before]'
      );

    const results =
      root.querySelector(
        '[data-pnx-results]'
      );

    const after =
      root.querySelector(
        '[data-pnx-after]'
      );

    const finalSection =
      root.querySelector(
        '[data-pnx-final]'
      );

    const rows =
      root.querySelector(
        '[data-pnx-rows]'
      );

    const swapButton =
      root.querySelector(
        '[data-pnx-swap]'
      );

    const changeButton =
      root.querySelector(
        '[data-pnx-change]'
      );


    if (
      !selectA ||
      !selectB ||
      !compareButton
    ) {
      console.error(
        '[PeerNest Compare] Required controls missing.',
        {
          selectA: !!selectA,
          selectB: !!selectB,
          compareButton: !!compareButton
        }
      );

      return;
    }


    /*
      Prevent this button from behaving like a
      form submit even if it sits inside a form.
    */

    compareButton.setAttribute(
      'type',
      'button'
    );


    let colleges = [];
    let collegeMap =
      new Map();

    // PNX_COMPARE_COLLEGE_CHANGE_REFRESH_20261020
    // Only the latest requested college pair may update the displayed mentors.
    let comparisonRequestVersion = 0;


    const fields = [
      {
        key:'academics_summary',
        label:'Academics',
        icon:'graduation-cap',
        ask:'Ask about workload, faculty and teaching quality'
      },
      {
        key:'fees_summary',
        label:'Fees',
        icon:'wallet-cards',
        ask:'Ask about extra and unexpected costs'
      },
      {
        key:'entrance_exams_summary',
        label:'Entrance Exams',
        icon:'file-check-2',
        ask:'Ask what admission was actually like'
      },
      {
        key:'placements_summary',
        label:'Placements',
        icon:'briefcase-business',
        ask:'Ask how placements work in practice'
      },
      {
        key:'campus_life_summary',
        label:'Campus Life',
        icon:'trees',
        ask:'Ask what a normal day on campus feels like'
      },
      {
        key:'hostel_summary',
        label:'Hostel & Accommodation',
        icon:'bed-double',
        ask:'Ask about food, rules and living conditions'
      },
      {
        key:'clubs_summary',
        label:'Clubs & Activities',
        icon:'users',
        ask:'Ask which clubs are genuinely active'
      },
      {
        key:'location_summary',
        label:'Location',
        icon:'map-pin',
        ask:'Ask about commute, safety and the surrounding area'
      },
      {
        key:'student_culture_summary',
        label:'Student Culture',
        icon:'heart-handshake',
        ask:'Ask whether you would actually fit in'
      },
      {
        key:'student_insights_summary',
        label:'Student Insights',
        icon:'message-circle-question',
        ask:'Ask what students wish they knew before joining'
      }
    ];


    function setError(message = '') {
      if (!errorBox) return;

      if (!message) {
        errorBox.hidden = true;
        errorBox.textContent = '';
        return;
      }

      errorBox.textContent =
        message;

      show(errorBox);
    }


    function updateText(
      selector,
      value
    ) {
      const element =
        root.querySelector(selector);

      if (!element) return;

      element.textContent =
        value || '';
    }


    function updateImage(
      selector,
      college
    ) {
      const image =
        root.querySelector(selector);

      if (!image) return;

      if (college.image_url) {
        image.src =
          college.image_url;

        image.alt =
          college.name || '';
      }
    }


    function shortName(college) {
      return (
        college.short_name ||
        college.name ||
        ''
      );
    }


    function locationText(college) {
      return [
        college.city,
        college.state
      ]
        .filter(Boolean)
        .join(', ');
    }


    function buildOption(
      college
    ) {
      const option =
        document.createElement(
          'option'
        );

      option.value =
        college.id;

      option.textContent =
        college.name;

      return option;
    }


    function populateSelectors() {
      const requestedParams =
        new URLSearchParams(
          window.location.search
        );

      const requestedCollege =
        requestedParams.get(
          'college'
        );

      const requestedCollege2 =
        requestedParams.get(
          'college2'
        );

      const autoCompare =
        requestedParams.get(
          'autocompare'
        ) === '1';


      selectA.innerHTML =
        '<option value="">Choose first college</option>';

      selectB.innerHTML =
        '<option value="">Choose second college</option>';


      colleges.forEach(college => {
        selectA.appendChild(
          buildOption(college)
        );

        selectB.appendChild(
          buildOption(college)
        );
      });


      if (
        requestedCollege &&
        collegeMap.has(
          requestedCollege
        )
      ) {
        selectA.value =
          requestedCollege;
      }


      if (
        requestedCollege2 &&
        collegeMap.has(
          requestedCollege2
        ) &&
        requestedCollege2 !==
          requestedCollege
      ) {
        selectB.value =
          requestedCollege2;
      }


      root.dataset.pnxAutoCompare =
        autoCompare
          ? '1'
          : '0';


      syncDisabledOptions();
    }


    function syncDisabledOptions() {
      const a =
        selectA.value;

      const b =
        selectB.value;


      [...selectA.options]
        .forEach(option => {
          if (!option.value) return;

          option.disabled =
            option.value === b;
        });


      [...selectB.options]
        .forEach(option => {
          if (!option.value) return;

          option.disabled =
            option.value === a;
        });
    }


    function comparisonValue(
      comparison,
      key
    ) {
      const value =
        comparison?.[key];

      if (
        value == null ||
        !String(value).trim()
      ) {
        return null;
      }

      return String(value).trim();
    }


    function renderRows(
      collegeA,
      collegeB,
      comparisonA,
      comparisonB
    ) {
      if (!rows) {
        return;
      }


      rows.innerHTML = '';


      fields.forEach(field => {
        const valueA =
          comparisonValue(
            comparisonA,
            field.key
          );

        const valueB =
          comparisonValue(
            comparisonB,
            field.key
          );


        const row =
          document.createElement(
            'article'
          );

        row.className =
          'pnx-compare-row';


        row.innerHTML = `

          <div
            class="pnx-value pnx-value--left"
          >

            <strong>
              ${escapeHTML(shortName(collegeA))}
            </strong>

            <div class="pnx-value-main">

              ${
                valueA
                  ? escapeHTML(valueA)
                  : 'Verified data not added yet'
              }

            </div>

            <span class="pnx-ask">
              Ask a student →
            </span>

          </div>


          <div class="pnx-compare-label">

            <i
              data-lucide="${field.icon}"
              aria-hidden="true"
            ></i>

            <strong>
              ${escapeHTML(field.label)}
            </strong>

            <small>
              ${escapeHTML(field.ask)}
            </small>

          </div>


          <div
            class="pnx-value pnx-value--right"
          >

            <strong>
              ${escapeHTML(shortName(collegeB))}
            </strong>

            <div class="pnx-value-main">

              ${
                valueB
                  ? escapeHTML(valueB)
                  : 'Verified data not added yet'
              }

            </div>

            <span class="pnx-ask">
              Ask a student →
            </span>

          </div>

        `;


        rows.appendChild(row);
      });
    }


    /* PN6_DIRECT_COLLEGE_MENTORS */

    function mentorMarkup(
      mentors,
      college,
      side
    ) {

      const source =
        Array.isArray(mentors)
          ? mentors
          : [];


      if (!source.length) {

        return `
          <div class="pnx-mentor-empty">

            <strong>
              No visible mentors yet
            </strong>

            <p>
              Approved mentors from
              ${escapeHTML(
                college?.name ||
                'this college'
              )}
              will appear here automatically.
            </p>

          </div>
        `;

      }


      return source
        .slice(0,3)
        .map(mentor => {

          const name =
            mentor.display_name ||
            'PeerNest Mentor';


          const initials =
            name
              .trim()
              .split(/\s+/)
              .slice(0,2)
              .map(part =>
                part.charAt(0)
              )
              .join('')
              .toUpperCase() ||
            'PN';


          const collegeName =
            college?.name ||
            mentor.college_name ||
            'PeerNest College';


          const program =
            mentor.program_name ||
            'Student Mentor';


          const year =
            mentor.graduation_year
              ? `Class of ${escapeHTML(
                  String(
                    mentor.graduation_year
                  )
                )}`
              : 'Current student';


          const rating =
            Number(
              mentor.rating ||
              0
            );


          const reviews =
            Number(
              mentor.review_count ||
              0
            );


          const ratingText =
            rating > 0
              ? `${rating.toFixed(1)}${
                  reviews
                    ? ` · ${reviews}`
                    : ''
                }`
              : 'New';


          const bio =
            mentor.bio ||
            `Ask ${name.split(/\s+/)[0]} about academics, admissions, campus life and the real student experience.`;


          const price =
            Number(
              mentor.session_price ||
              0
            );


          const priceText =
            price > 0
              ? `From ₹${price.toLocaleString(
                  'en-IN'
                )}`
              : 'View session options';


          const profileURL =
            mentor.slug
              ? `/pages/mentor-profile?slug=${encodeURIComponent(
                  mentor.slug
                )}`
              : `/pages/mentors?college=${encodeURIComponent(
                  college?.id || ''
                )}`;


          const photo =
            mentor.photo_url
              ? `
                <img
                  src="${escapeHTML(
                    mentor.photo_url
                  )}"
                  alt="${escapeHTML(name)}"
                  loading="lazy"
                >
              `
              : `
                <span class="pnm-card__placeholder">
                  ${escapeHTML(initials)}
                </span>
              `;


          return `

            <article
              class="pnm-card pnx-compare-mentor-card"
              data-compare-mentor-card
            >

              <div class="pnm-card__image">

                ${photo}

                <span class="pnm-card__verified">
                  ✓ Verified Student
                </span>

              </div>


              <div class="pnm-card__body">

                <div class="pnm-card__head">

                  <h4>
                    ${escapeHTML(name)}
                  </h4>

                  <span class="pnm-card__rating">
                    <b>★</b>
                    ${escapeHTML(ratingText)}
                  </span>

                </div>


                <div class="pnm-card__college">
                  ${escapeHTML(collegeName)}
                </div>


                <div class="pnm-card__meta">
                  ${escapeHTML(program)}
                  ·
                  ${year}
                </div>


                <div class="pnm-card__tags">

                  <span class="pnm-card__tag">
                    Verified
                  </span>

                  <span class="pnm-card__tag">
                    Student Mentor
                  </span>

                </div>


                <p class="pnm-card__bio">
                  ${escapeHTML(bio)}
                </p>


                <div class="pnm-card__price">

                  Session options

                  <strong>
                    ${escapeHTML(priceText)}
                  </strong>

                </div>


                <div class="pnm-card__actions">

                  <a
                    href="${profileURL}"
                    class="pnm-card__action pnm-card__action--ghost"
                    onclick="event.stopPropagation();"
                  >
                    View Profile
                  </a>


                  <button
                    type="button"
                    class="pnm-card__action pnm-card__action--primary"
                    data-pnx-mentor-choice
                    data-side="${escapeHTML(side)}"
                    data-mentor-id="${escapeHTML(
                      mentor.id
                    )}"
                    aria-pressed="false"
                  >
                    Select Mentor
                  </button>

                </div>

              </div>

            </article>

          `;

        })
        .join('');

    }


    function renderMentors(
      collegeA,
      collegeB,
      mentorsA,
      mentorsB
    ) {
      const containerA =
        root.querySelector(
          '[data-pnx-mentors-a]'
        );

      const containerB =
        root.querySelector(
          '[data-pnx-mentors-b]'
        );


      if (containerA) {
        containerA.innerHTML =
          mentorMarkup(
            mentorsA,
            collegeA,
            'a'
          );
      }


      if (containerB) {
        containerB.innerHTML =
          mentorMarkup(
            mentorsB,
            collegeB,
            'b'
          );
      }
    }


    function setLink(
      selector,
      url
    ) {
      const element =
        root.querySelector(selector);

      if (!element) return;

      if (
        element.tagName ===
        'A'
      ) {
        element.href =
          url;
      }
      else {
        element.dataset.href =
          url;

        element.onclick = event => {
          event.preventDefault();

          if (element.dataset.href) {
            window.location.href =
              element.dataset.href;
          }
        };
      }
    }


    function updateCollegeUI(
      collegeA,
      collegeB
    ) {
      updateImage(
        '[data-pnx-a-image]',
        collegeA
      );

      updateText(
        '[data-pnx-a-name]',
        collegeA.name
      );

      updateText(
        '[data-pnx-a-location]',
        locationText(collegeA)
      );

      updateText(
        '[data-pnx-a-short]',
        shortName(collegeA)
      );


      updateImage(
        '[data-pnx-b-image]',
        collegeB
      );

      updateText(
        '[data-pnx-b-name]',
        collegeB.name
      );

      updateText(
        '[data-pnx-b-location]',
        locationText(collegeB)
      );

      updateText(
        '[data-pnx-b-short]',
        shortName(collegeB)
      );


      [
        '[data-pnx-table-a]',
        '[data-pnx-duo-a]',
        '[data-pnx-live-college-a]'
      ]
        .forEach(selector =>
          updateText(
            selector,
            shortName(collegeA)
          )
        );


      [
        '[data-pnx-table-b]',
        '[data-pnx-duo-b]',
        '[data-pnx-live-college-b]'
      ]
        .forEach(selector =>
          updateText(
            selector,
            shortName(collegeB)
          )
        );


      const mentorURLA =
        `/pages/mentors?college=${encodeURIComponent(
          collegeA.id
        )}`;


      const mentorURLB =
        `/pages/mentors?college=${encodeURIComponent(
          collegeB.id
        )}`;


      const collegeURLA =
        `/pages/college?view=college&college=${encodeURIComponent(
          collegeA.slug || collegeA.id
        )}`;


      const collegeURLB =
        `/pages/college?view=college&college=${encodeURIComponent(
          collegeB.slug || collegeB.id
        )}`;


      setLink(
        '[data-pnx-college-link-a]',
        collegeURLA
      );

      setLink(
        '[data-pnx-college-link-b]',
        collegeURLB
      );


      setLink(
        '[data-pnx-book-a]',
        mentorURLA
      );

      setLink(
        '[data-pnx-book-b]',
        mentorURLB
      );

      setLink(
        '[data-pnx-final-a]',
        mentorURLA
      );

      setLink(
        '[data-pnx-final-b]',
        mentorURLB
      );


      const duo =
        root.querySelector(
          '[data-pnx-duo-book]'
        );

      if (duo) {
        duo.dataset.collegeA =
          collegeA.id;

        duo.dataset.collegeB =
          collegeB.id;
      }
    }




    /* PN_COMPARE_MENTOR_STAGE */

    function mountMentorStage() {

      const stage =
        root.querySelector(
          '[data-pnx-mentor-stage]'
        );


      if (!stage) return;


      const hostA =
        stage.querySelector(
          '[data-pnx-stage-host-a]'
        );

      const hostB =
        stage.querySelector(
          '[data-pnx-stage-host-b]'
        );


      const mentorsA =
        root.querySelector(
          '[data-pnx-mentors-a]'
        );

      const mentorsB =
        root.querySelector(
          '[data-pnx-mentors-b]'
        );


      /*
        Capture the old wrappers BEFORE moving
        the live mentor containers.
      */

      const oldPreviewA =
        mentorsA?.closest(
          '.pnx-mentor-preview'
        );

      const oldPreviewB =
        mentorsB?.closest(
          '.pnx-mentor-preview'
        );


      if (
        hostA &&
        mentorsA &&
        mentorsA.parentElement !== hostA
      ) {

        hostA.appendChild(
          mentorsA
        );

      }


      if (
        hostB &&
        mentorsB &&
        mentorsB.parentElement !== hostB
      ) {

        hostB.appendChild(
          mentorsB
        );

      }


      mentorsA?.classList.add(
        'pnx-mentor-stage__slots'
      );

      mentorsB?.classList.add(
        'pnx-mentor-stage__slots'
      );


      oldPreviewA?.classList.add(
        'pnx-original-mentor-preview--relocated'
      );

      oldPreviewB?.classList.add(
        'pnx-original-mentor-preview--relocated'
      );



      /*
        Move the EXISTING duo booking button.
        Its existing click listener remains attached.
      */

      const duoButton =
        root.querySelector(
          '[data-pnx-duo-book]'
        );

      const duoNote =
        root.querySelector(
          '[data-pnx-duo-note]'
        );


      const oldDuo =
        duoButton?.closest(
          '.pnx-duo'
        );


      const duoHost =
        stage.querySelector(
          '[data-pnx-stage-duo-host]'
        );

      const noteHost =
        stage.querySelector(
          '[data-pnx-stage-note-host]'
        );


      if (
        duoButton &&
        duoHost &&
        duoButton.parentElement !== duoHost
      ) {

        duoHost.appendChild(
          duoButton
        );

      }


      if (
        duoNote &&
        noteHost &&
        duoNote.parentElement !== noteHost
      ) {

        noteHost.appendChild(
          duoNote
        );

      }


      /*
       * PN_COMPARE_BOOKER_VISIBILITY_FIX_20261018
       * The original .pnx-duo is hidden after its booking button is
       * relocated into the visible mentor stage. The shared session
       * panel must move with it, otherwise show(sharedPanel) works
       * but the entire panel stays invisible inside display:none.
       */
      const sharedBookingPanel = root.querySelector(
        '[data-pnx-shared-panel]'
      );

      const visibleBookingStage = stage.querySelector(
        '.pnx-mentor-stage__booking'
      );

      if (
        sharedBookingPanel &&
        visibleBookingStage &&
        sharedBookingPanel.parentElement !== visibleBookingStage
      ) {
        visibleBookingStage.appendChild(sharedBookingPanel);
      }

      duoButton?.classList.add(
        'pnx-mentor-stage__book'
      );

      duoNote?.classList.add(
        'pnx-mentor-stage__note'
      );


      oldDuo?.classList.add(
        'pnx-original-duo--relocated'
      );



      /*
        Mirror the already-generated college profile
        URLs into the small pills.
      */

      const sourceLinkA =
        root.querySelector(
          '[data-pnx-college-link-a]'
        );

      const sourceLinkB =
        root.querySelector(
          '[data-pnx-college-link-b]'
        );


      const profileA =
        stage.querySelector(
          '[data-pnx-stage-college-a]'
        );

      const profileB =
        stage.querySelector(
          '[data-pnx-stage-college-b]'
        );


      if (
        profileA &&
        sourceLinkA?.href
      ) {

        profileA.href =
          sourceLinkA.href;

      }


      if (
        profileB &&
        sourceLinkB?.href
      ) {

        profileB.href =
          sourceLinkB.href;

      }



      /*
        Move the college-profile pills BELOW
        each live mentor list.
      */

      if (
        profileA &&
        hostA &&
        profileA.previousElementSibling !== hostA
      ) {

        hostA.insertAdjacentElement(
          'afterend',
          profileA
        );

      }


      if (
        profileB &&
        hostB &&
        profileB.previousElementSibling !== hostB
      ) {

        hostB.insertAdjacentElement(
          'afterend',
          profileB
        );

      }



      /*
        Hide the original large college-profile cards
        while preserving their DOM/data attributes for
        the existing comparison JS.

        We find the nearest ancestor containing:
        image + name + college-profile link.
      */

      function hideOriginalCollegeProfile(
        imageSelector,
        nameSelector,
        linkSelector
      ) {

        const image =
          root.querySelector(
            imageSelector
          );

        if (!image) return;


        let node =
          image.parentElement;


        while (
          node &&
          node !== root
        ) {

          if (
            node.querySelector?.(
              nameSelector
            ) &&
            node.querySelector?.(
              linkSelector
            )
          ) {

            node.classList.add(
              'pnx-college-profile-card--hidden'
            );

            return;

          }


          node =
            node.parentElement;

        }

      }


      hideOriginalCollegeProfile(
        '[data-pnx-a-image]',
        '[data-pnx-a-name]',
        '[data-pnx-college-link-a]'
      );


      hideOriginalCollegeProfile(
        '[data-pnx-b-image]',
        '[data-pnx-b-name]',
        '[data-pnx-college-link-b]'
      );




      /*
        Use the live college names.
      */

      const collegeNameA =
        root.querySelector(
          '[data-pnx-a-name]'
        )
        ?.textContent
        ?.trim() ||
        root.querySelector(
          '[data-pnx-table-a]'
        )
        ?.textContent
        ?.trim() ||
        'College 01';


      const collegeNameB =
        root.querySelector(
          '[data-pnx-b-name]'
        )
        ?.textContent
        ?.trim() ||
        root.querySelector(
          '[data-pnx-table-b]'
        )
        ?.textContent
        ?.trim() ||
        'College 02';


      const labelA =
        stage.querySelector(
          '[data-pnx-stage-college-a-name]'
        );

      const labelB =
        stage.querySelector(
          '[data-pnx-stage-college-b-name]'
        );


      if (labelA) {
        labelA.textContent =
          `${collegeNameA} profile`;
      }


      if (labelB) {
        labelB.textContent =
          `${collegeNameB} profile`;
      }

    }

    /* PN_COMPARE_MENTOR_STAGE_END */


    async function runComparison(
      event,
      options = {}
    ) {
      event?.preventDefault();
      event?.stopPropagation();


      setError('');


      const collegeAId =
        selectA.value;

      const collegeBId =
        selectB.value;


      if (
        !collegeAId ||
        !collegeBId
      ) {
        setError(
          'Choose two colleges before comparing.'
        );

        return;
      }


      if (
        collegeAId ===
        collegeBId
      ) {
        setError(
          'Choose two different colleges.'
        );

        return;
      }


      const collegeA =
        collegeMap.get(
          collegeAId
        );

      const collegeB =
        collegeMap.get(
          collegeBId
        );


      if (
        !collegeA ||
        !collegeB
      ) {
        setError(
          'Those colleges could not be loaded.'
        );

        return;
      }


      const requestVersion =
        ++comparisonRequestVersion;

      compareButton.disabled =
        true;

      compareButton.setAttribute(
        'aria-busy',
        'true'
      );


      try {
        const [
          comparisonA,
          comparisonB,
          mentorsA,
          mentorsB
        ] = await Promise.all([

          window.PeerNestDB
            .getCollegeComparison(
              collegeAId
            )
            .catch(error => {

              console.warn(
                '[PeerNest Compare] College A detail unavailable:',
                error
              );

              return null;

            }),

          window.PeerNestDB
            .getCollegeComparison(
              collegeBId
            )
            .catch(error => {

              console.warn(
                '[PeerNest Compare] College B detail unavailable:',
                error
              );

              return null;

            }),

          window.PeerNestDB
            .getCollegeMentors(
              collegeAId,
              12
            )
            .catch(error => {

              console.warn(
                '[PeerNest Compare] College A mentors unavailable:',
                error
              );

              return [];

            }),

          window.PeerNestDB
            .getCollegeMentors(
              collegeBId,
              12
            )
            .catch(error => {

              console.warn(
                '[PeerNest Compare] College B mentors unavailable:',
                error
              );

              return [];

            })

        ]);

        // Ignore an obsolete response after either college has changed.
        if (
          requestVersion !== comparisonRequestVersion ||
          selectA.value !== collegeAId ||
          selectB.value !== collegeBId
        ) {
          return;
        }

        updateCollegeUI(
          collegeA,
          collegeB
        );


        renderRows(
          collegeA,
          collegeB,
          comparisonA || {},
          comparisonB || {}
        );


        renderMentors(
          collegeA,
          collegeB,
          mentorsA,
          mentorsB
        );

        mountMentorStage();



        hide(before);

        show(results);
        show(after);
        show(finalSection);


        root.dataset
          .pnxSelectedCollegeA =
          collegeA.id;

        root.dataset
          .pnxSelectedCollegeB =
          collegeB.id;


        refreshLucideIcons();


        if (options.scroll !== false) {
          requestAnimationFrame(
            () => {
              // A newer selection may have happened before the frame.
              if (requestVersion === comparisonRequestVersion) {
                results?.scrollIntoView({
                  behavior:'smooth',
                  block:'start'
                });
              }
            }
          );
        }


        console.log(
          '[PeerNest Compare] Loaded:',
          collegeA.name,
          'vs',
          collegeB.name
        );
      }
      catch (error) {
        if (requestVersion === comparisonRequestVersion) {
          console.error(
            '[PeerNest Compare] Compare failed:',
            error
          );

          setError(
            'The comparison could not be loaded. Please try again.'
          );
        }
      }
      finally {
        if (requestVersion === comparisonRequestVersion) {
          compareButton.disabled =
            false;

          compareButton.removeAttribute(
            'aria-busy'
          );
        }
      }
    }


    function onCollegeSelectionChanged() {
      syncDisabledOptions();

      // Invalidate in-flight comparisons before updating or clearing the UI.
      ++comparisonRequestVersion;
      setError('');

      // Do not leave old mentors or an old booking panel displayed for
      // the newly selected college pair while the replacement loads.
      show(before);
      hide(results);
      hide(after);
      hide(finalSection);

      compareButton.disabled = false;
      compareButton.removeAttribute('aria-busy');

      const collegeAId = selectA.value;
      const collegeBId = selectB.value;

      if (
        !collegeAId ||
        !collegeBId ||
        collegeAId === collegeBId ||
        !collegeMap.has(collegeAId) ||
        !collegeMap.has(collegeBId)
      ) {
        return;
      }

      // Once both colleges are chosen, fetch their current comparison
      // and mentor lists immediately. The Compare button remains usable;
      // automatic refresh avoids unexpectedly scrolling the selector away.
      void runComparison(null, { scroll: false });
    }


    selectA.addEventListener(
      'change',
      onCollegeSelectionChanged
    );


    selectB.addEventListener(
      'change',
      onCollegeSelectionChanged
    );


    if (
      root.dataset
        .pnxAutoCompare === '1' &&
      selectA.value &&
      selectB.value &&
      selectA.value !==
        selectB.value
    ) {

      root.dataset
        .pnxAutoCompare = '0';


      setTimeout(
        () => {

          compareButton.click();

        },
        50
      );

    }


    swapButton
      ?.addEventListener(
        'click',
        event => {
          event.preventDefault();

          const oldA =
            selectA.value;

          selectA.value =
            selectB.value;

          selectB.value =
            oldA;

          onCollegeSelectionChanged();
        }
      );


    changeButton
      ?.addEventListener(
        'click',
        event => {
          event.preventDefault();

          show(before);

          hide(results);
          hide(after);
          hide(finalSection);

          before
            ?.scrollIntoView({
              behavior:'smooth',
              block:'start'
            });
        }
      );


    compareButton.addEventListener(
      'click',
      runComparison
    );


    /* PN6_COMPARE_LIVE_BOOKING */

    const duoButton =
      root.querySelector(
        '[data-pnx-duo-book]'
      );


    const sharedPanel =
      root.querySelector(
        '[data-pnx-shared-panel]'
      );


    async function compareLiveRPC(
      name,
      body = {}
    ) {

      return window.PeerNestDB
        .request(
          `rpc/${name}`,
          '',
          {
            method:'POST',
            body
          }
        );

    }


    function formatCompareLiveTime(
      value
    ) {

      const date =
        new Date(value);


      if (
        Number.isNaN(
          date.getTime()
        )
      ) {
        return '';
      }


      return new Intl.DateTimeFormat(
        undefined,
        {
          weekday:'short',
          day:'numeric',
          month:'short',
          hour:'numeric',
          minute:'2-digit'
        }
      ).format(date);

    }


    function getCompareLiveBooker() {

      if (!sharedPanel) {
        return null;
      }


      let booker =
        sharedPanel.querySelector(
          '[data-pnx-compare-live-booker]'
        );


      if (!booker) {

        booker =
          document.createElement(
            'div'
          );


        booker.className =
          'pnx-compare-live-booker';


        booker.setAttribute(
          'data-pnx-compare-live-booker',
          ''
        );


        sharedPanel.appendChild(
          booker
        );

      }


      return booker;

    }




    /* PN_COMPARE_PAID_ONLY_V1 — shared Razorpay endpoints, no changes to Quick/Deep */
    function compareLivePriceLabel(amount, currency = 'INR') {
      const value = Number(amount);
      if (!Number.isFinite(value) || value <= 0) return 'Price unavailable';
      try {
        return new Intl.NumberFormat('en-IN', {
          style:'currency',currency:String(currency || 'INR'),
          maximumFractionDigits:2
        }).format(value);
      }
      catch (_) { return `${value.toFixed(2)} ${currency}`; }
    }

    function clearComparePending(booker) {
      ['pendingPaymentId','pendingBookingId','pendingExpiresAt',
       'pendingMentorA','pendingMentorB','pendingStartsAt',
       'pendingPrice','pendingCurrency'].forEach(key => {
        delete booker.dataset[key];
      });
    }

    async function loadCompareRazorpay() {
      if (window.Razorpay) return;
      await new Promise((resolve,reject) => {
        const url='https://checkout.razorpay.com/v1/checkout.js';
        let script=document.querySelector(`script[src="${url}"]`);
        if (!script) {
          script=document.createElement('script');
          script.src=url;
          script.async=true;
        }
        script.addEventListener('load', resolve, {once:true});
        script.addEventListener('error', () => reject(new Error(
          'Razorpay checkout could not be loaded.')), {once:true});
        if (window.Razorpay) resolve();
        else if (!script.isConnected) document.head.appendChild(script);
      });
      if (!window.Razorpay) throw new Error('Razorpay checkout is unavailable.');
    }

    /* PN_COMPARE_CHECKOUT_VISIBLE_ERROR_20261018
       Surface rejected student-only reservations next to Pay, not the distant college picker. */
    function showCompareCheckoutNotice(booker, message = '') {
      const payButton = booker?.querySelector('[data-pnx-compare-live-confirm]');
      if (!payButton) return;
      let notice = booker.querySelector('[data-pnx-compare-checkout-notice]');
      if (!notice && message) {
        notice = document.createElement('p');
        notice.setAttribute('data-pnx-compare-checkout-notice', '');
        notice.setAttribute('role', 'alert');
        notice.style.cssText = 'margin:12px 0 0;padding:12px 14px;border:1px solid #ecd0c8;border-radius:12px;background:#fff8f5;color:#8b352b;font-size:13px;line-height:1.5;text-align:left;';
        payButton.insertAdjacentElement('afterend', notice);
      }
      if (!notice) return;
      notice.textContent = message;
      notice.hidden = !message;
    }

    async function runComparePaidCheckout(booker, confirm, mentorAId, mentorBId, startsAt) {
      if (booker.dataset.paymentUncertain === '1') {
        throw new Error('Payment verification needs attention. Do not pay again. Check My Bookings or contact PeerNest support.');
      }
      const session=await window.PeerNestDB.getSession();
      if (!session?.access_token) throw new Error('Please sign in to book Compare Live.');
      const stillValid=Boolean(
        booker.dataset.pendingPaymentId &&
        new Date(booker.dataset.pendingExpiresAt || 0).getTime() > Date.now() &&
        booker.dataset.pendingMentorA === mentorAId &&
        booker.dataset.pendingMentorB === mentorBId &&
        booker.dataset.pendingStartsAt === startsAt
      );
      if (booker.dataset.pendingPaymentId && !stillValid) {
        await compareLiveRPC('pn_pay_cancel_compare_reservation',{
          p_payment_id:booker.dataset.pendingPaymentId
        });
        clearComparePending(booker);
      }
      let reservation;
      if (stillValid) {
        reservation={
          payment_id:booker.dataset.pendingPaymentId,
          booking_id:booker.dataset.pendingBookingId,
          expires_at:booker.dataset.pendingExpiresAt,
          amount:Number(booker.dataset.pendingPrice),
          currency:booker.dataset.pendingCurrency
        };
      }
      else {
        reservation=await compareLiveRPC('pn_pay_reserve_compare_live_booking',{
          p_mentor_a:mentorAId,p_mentor_b:mentorBId,
          p_starts_at:startsAt,p_student_notes:null
        });
        if (!reservation?.payment_id || !reservation?.booking_id) {
          throw new Error('Compare checkout reservation could not be created.');
        }
        booker.dataset.pendingPaymentId=reservation.payment_id;
        booker.dataset.pendingBookingId=reservation.booking_id;
        booker.dataset.pendingExpiresAt=reservation.expires_at;
        booker.dataset.pendingMentorA=mentorAId;
        booker.dataset.pendingMentorB=mentorBId;
        booker.dataset.pendingStartsAt=startsAt;
        booker.dataset.pendingPrice=reservation.amount;
        booker.dataset.pendingCurrency=reservation.currency;
      }
      if (Number(reservation.amount) !== Number(booker.dataset.displayPrice) ||
          reservation.currency !== booker.dataset.displayCurrency) {
        await compareLiveRPC('pn_pay_cancel_compare_reservation',{
          p_payment_id:reservation.payment_id
        });
        clearComparePending(booker);
        throw new Error('Compare Live pricing changed. Reopen booking to view the latest price.');
      }
      confirm.textContent='Preparing secure payment…';
      const order=await window.PeerNestDB.invokeFunction('razorpay-create-order',{
        payment_id:reservation.payment_id
      });
      if (!order?.razorpay_key_id || !order?.razorpay_order_id || !order?.amount || !order?.currency) {
        throw new Error('Razorpay checkout could not be prepared.');
      }
      await loadCompareRazorpay();
      confirm.textContent='Complete payment to confirm both mentors';
      const verified=await new Promise((resolve,reject) => {
        let settled=false;
        let verificationStarted=false;
        const checkout=new window.Razorpay({
          key:order.razorpay_key_id,amount:order.amount,currency:order.currency,
          name:'PeerNest',description:'Compare Live — two mentors, 30 minutes',
          order_id:order.razorpay_order_id,
          handler:async response => {
            if (settled || verificationStarted) return;
            verificationStarted=true;
            booker.dataset.paymentUncertain='1';
            confirm.textContent='Verifying payment…';
            try {
              const result=await window.PeerNestDB.invokeFunction('razorpay-verify-payment',{
                payment_id:reservation.payment_id,
                razorpay_order_id:response.razorpay_order_id,
                razorpay_payment_id:response.razorpay_payment_id,
                razorpay_signature:response.razorpay_signature
              });
              if (result?.fulfilled !== true || result?.requires_refund === true) {
                throw new Error('Payment received but Compare Live could not be confirmed. Do not pay again; contact PeerNest support.');
              }
              settled=true;
              delete booker.dataset.paymentUncertain;
              resolve(result);
            }
            catch (error) { settled=true; reject(error); }
          },
          modal:{ondismiss:() => {
            if (settled || verificationStarted) return;
            settled=true;
            reject(new Error('Payment not completed. Click Pay again to retry before your 15-minute reservation expires.'));
          }},
          theme:{color:'#5B5FFB'}
        });
        checkout.on('payment.failed',response => {
          if (settled || verificationStarted) return;
          settled=true;
          reject(new Error(response?.error?.description ||
            'Payment failed. Click Pay again to retry before your reservation expires.'));
        });
        checkout.open();
      });
      clearComparePending(booker);
      return {verified,bookingId:reservation.booking_id};
    }


    async function openCompareLiveBooking() {

      setError('');


      const mentorA =
        root.querySelector(
          '[data-pnx-mentor-choice][data-side="a"].is-selected'
        );


      const mentorB =
        root.querySelector(
          '[data-pnx-mentor-choice][data-side="b"].is-selected'
        );


      if (!mentorA || !mentorB) {

        setError(
          'Select one mentor from each college before booking both.'
        );


        root.querySelector(
          '[data-pnx-mentors-a]'
        )
          ?.scrollIntoView({
            behavior:'smooth',
            block:'center'
          });


        return;

      }


      const mentorAId =
        mentorA.dataset.mentorId;


      const mentorBId =
        mentorB.dataset.mentorId;


      const booker =
        getCompareLiveBooker();


      if (
        !mentorAId ||
        !mentorBId ||
        !booker
      ) {
        return;
      }


      show(
        sharedPanel
      );


      if (booker.dataset.paymentUncertain === '1') {
        setError('A Compare payment may have been received. Do not pay again. Check My Bookings or contact PeerNest support.');
        return;
      }
      if (booker.dataset.pendingPaymentId) {
        try {
          await compareLiveRPC('pn_pay_cancel_compare_reservation',{
            p_payment_id:booker.dataset.pendingPaymentId
          });
          clearComparePending(booker);
        }
        catch (error) {
          setError(error?.message || 'Could not reset previous Compare reservation.');
          return;
        }
      }

      booker.dataset.mentorA =
        mentorAId;


      booker.dataset.mentorB =
        mentorBId;


      booker.dataset.startsAt =
        '';


      booker.innerHTML = `

        <div class="pnx-compare-live-booker__head">

          <strong>
            Finding a common time…
          </strong>

          <p>
            Checking when both selected mentors are available.
          </p>

        </div>

      `;


      sharedPanel.scrollIntoView({
        behavior:'smooth',
        block:'center'
      });


      try {

        const pricing=await compareLiveRPC('pn_get_compare_live_checkout_price');
        if (!pricing?.configured || !Number(pricing.amount) || Number(pricing.amount)<=0) {
          booker.innerHTML=`<div class="pnx-compare-live-booker__head">
            <strong>Compare Live pricing isn't available yet.</strong>
            <p>Please check again once the session price is configured.</p>
          </div>`;
          return;
        }
        booker.dataset.displayPrice=pricing.amount;
        booker.dataset.displayCurrency=pricing.currency;
        const displayPrice=compareLivePriceLabel(pricing.amount,pricing.currency);

        const result =
          await compareLiveRPC(
            'get_compare_live_common_slots',
            {
              p_mentor_a:
                mentorAId,

              p_mentor_b:
                mentorBId,

              p_limit:
                24
            }
          );


        // Checkout reservations last 15 minutes; don't offer a time
        // which could begin before checkout completes.
        const slots =
          Array.isArray(result)
            ? result.filter(slot =>
                new Date(slot.starts_at).getTime() > Date.now() + 15 * 60 * 1000
              )
            : [];


        if (!slots.length) {

          booker.innerHTML = `

            <div class="pnx-compare-live-booker__head">

              <strong>
                No common 30-minute time yet.
              </strong>

              <p>
                These mentors do not currently have overlapping availability.
                Check again after they add more slots.
              </p>

            </div>

          `;


          return;

        }


        booker.innerHTML = `

          <div class="pnx-compare-live-booker__head">

            <strong>
              Choose a shared 30-minute session
            </strong>

            <p>
              You + both mentors will use one Google Meet. Total: ${escapeHTML(displayPrice)}.
            </p>

          </div>


          <div class="pnx-compare-live-booker__slots">

            ${slots
              .map(
                slot => `

                  <button
                    type="button"
                    data-pnx-compare-live-slot="${escapeHTML(
                      slot.starts_at
                    )}"
                  >
                    ${escapeHTML(
                      formatCompareLiveTime(
                        slot.starts_at
                      )
                    )}
                  </button>

                `
              )
              .join('')}

          </div>


          <button
            type="button"
            class="pnx-compare-live-booker__confirm"
            data-pnx-compare-live-confirm
            disabled
          >
            Select a time first · ${escapeHTML(displayPrice)}
          </button>

        `;

      }
      catch (error) {

        console.error(
          '[PeerNest Compare Live] availability:',
          error
        );


        booker.innerHTML = `

          <div class="pnx-compare-live-booker__head">

            <strong>
              Common availability could not be loaded.
            </strong>

            <p>
              Please try again.
            </p>

          </div>

        `;

      }

    }


    duoButton?.setAttribute(
      'type',
      'button'
    );


    duoButton?.addEventListener(
      'click',
      event => {

        event.preventDefault();
        event.stopPropagation();

        openCompareLiveBooking();

      }
    );


    root.addEventListener(
      'click',
      async event => {

        const slotButton =
          event.target.closest(
            '[data-pnx-compare-live-slot]'
          );


        if (slotButton) {

          const booker =
            getCompareLiveBooker();


          if (!booker) {
            return;
          }


          booker
            .querySelectorAll(
              '[data-pnx-compare-live-slot]'
            )
            .forEach(button => {

              button.classList.toggle(
                'is-selected',
                button === slotButton
              );

            });


          booker.dataset.startsAt =
            slotButton.dataset
              .pnxCompareLiveSlot;


          const confirm =
            booker.querySelector(
              '[data-pnx-compare-live-confirm]'
            );


          if (confirm) {

            confirm.disabled =
              false;


            confirm.textContent =
              'Pay ' + compareLivePriceLabel(booker.dataset.displayPrice,booker.dataset.displayCurrency) +
              ' · Book Both Mentors';

          }


          return;

        }


        const confirm =
          event.target.closest(
            '[data-pnx-compare-live-confirm]'
          );


        if (!confirm) {
          return;
        }


        const booker =
          getCompareLiveBooker();


        const mentorAId =
          booker?.dataset
            ?.mentorA;


        const mentorBId =
          booker?.dataset
            ?.mentorB;


        const startsAt =
          booker?.dataset
            ?.startsAt;


        if (
          !mentorAId ||
          !mentorBId ||
          !startsAt
        ) {
          return;
        }


        showCompareCheckoutNotice(booker, '');

        confirm.disabled =
          true;


        confirm.textContent =
          'Booking…';


        try {

          const checkoutResult = await runComparePaidCheckout(
            booker,confirm,mentorAId,mentorBId,startsAt
          );

          const bookingId = checkoutResult.bookingId || '';

          booker.innerHTML = `

            <div class="pnx-compare-live-success">

              <strong>
                Compare Live payment verified ✓
              </strong>

              <p>
                Payment verified. Your shared 30-minute session with both mentors is confirmed.
              </p>

              ${
                bookingId
                  ? `
                    <a
                      href="/pages/student-dashboard?booking=${encodeURIComponent(
                        bookingId
                      )}"
                    >
                      View booking →
                    </a>
                  `
                  : ''
              }

            </div>

          `;

        }
        catch (error) {

          console.error(
            '[PeerNest Compare Live] booking:',
            error
          );


          confirm.disabled = booker.dataset.paymentUncertain === '1';


          confirm.textContent = booker.dataset.paymentUncertain === '1'
            ? 'Payment review needed — do not pay again'
            : 'Pay ' + compareLivePriceLabel(booker.dataset.displayPrice,booker.dataset.displayCurrency) +
              ' · Book Both Mentors';


          const bookingError = String(error?.message ||
            'Compare Live could not be booked.');
          const visibleError = /active student account|only student accounts|student account is required/i.test(bookingError)
            ? 'Compare Live checkout requires a student account. Sign out of Admin and sign in as a student, then choose the shared slot again.'
            : bookingError;
          showCompareCheckoutNotice(booker, visibleError);
          setError(visibleError);

        }

      }
    );



    /* PNX_COMPARE_MOBILE_CARD_GUARD_START
       The global mentor-listing script treats a tap on noninteractive parts
       of any .pnm-card as a request to open View Profile. Compare cards
       have separate Select Mentor buttons; prevent that global redirect.
       This is a bubble-phase listener on the Compare root, so existing
       root handlers still run. Only the explicit View Profile <a> navigates.
    */
    root.addEventListener('click', event => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const compareCard = target.closest('[data-compare-mentor-card]');
      if (!compareCard || !root.contains(compareCard)) return;
      // Let explicit profile links follow their own href, never a card tap.
      if (target.closest('a.pnm-card__action--ghost[href]')) return;
      event.stopPropagation();
    });
    /* PNX_COMPARE_MOBILE_CARD_GUARD_END */

    /*
      Mentor selection state.
    */

    root.addEventListener(
      'click',
      event => {
        const choice =
          event.target.closest(
            '[data-pnx-mentor-choice]'
          );

        if (!choice) return;

        event.preventDefault();


        const side =
          choice.dataset.side;


        root
          .querySelectorAll(
            `[data-pnx-mentor-choice][data-side="${side}"]`
          )
          .forEach(button => {
            button.classList.remove(
              'is-selected'
            );

            button.setAttribute(
              'aria-pressed',
              'false'
            );
          });


        choice.classList.add(
          'is-selected'
        );

        choice.setAttribute(
          'aria-pressed',
          'true'
        );
      }
    );


    /*
      Load the colleges exactly once
      from Supabase.
    */

    window.PeerNestDB
      .getPublishedColleges()
      .then(data => {
        colleges =
          Array.isArray(data)
            ? data
            : [];


        collegeMap =
          new Map(
            colleges.map(
              college => [
                college.id,
                college
              ]
            )
          );


        populateSelectors();

        refreshLucideIcons();


        console.log(
          `[PeerNest Compare] ${colleges.length} colleges ready.`
        );
      })
      .catch(error => {
        console.error(
          '[PeerNest Compare] Colleges failed to load:',
          error
        );

        setError(
          'Colleges could not be loaded. Refresh the page and try again.'
        );
      });
  }


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      { once:true }
    );
  }
  else {
    boot();
  }


  document.addEventListener(
    'peernest:supabase-ready',
    boot
  );


  document.addEventListener(
    'shopify:section:load',
    () => {
      const root =
        document.querySelector(
          '[data-pnx]'
        );

      if (root) {
        delete root.dataset
          .pnxCanonicalReady;
      }

      boot();
    }
  );
})();
